import { CallPut, TradeDirection } from 'utils/shared/trades/types';
import type { Trade } from 'utils/shared/trades/types';
import { getOptionFlowSideCode } from 'utils/shared/trades/getOptionFlowRowSentiment';
import { normalizeCallPut } from 'utils/shared/trades/normalizeCallPut';

export function getTradePositionSign(trade: Trade): 1 | -1 | 0 {
  const sideCode = getOptionFlowSideCode(trade);

  if (sideCode === TradeDirection.Ask || sideCode === TradeDirection.AboveAsk) {
    return 1;
  }

  if (sideCode === TradeDirection.Bid || sideCode === TradeDirection.BelowBid) {
    return -1;
  }

  return 0;
}

export function getDirectionalFlowSign(trade: Trade): 1 | -1 | 0 {
  const positionSign = getTradePositionSign(trade);
  if (positionSign === 0) return 0;
  const cp = normalizeCallPut(trade.cp);
  if (cp === CallPut.Call) return positionSign;
  if (cp === CallPut.Put) return positionSign === 1 ? -1 : 1;
  return 0;
}
